import {Injectable} from '@angular/core';
import {DocumentModel} from '../models/document.model';
import {GeneralService} from './general.service';
import {DocumentTypes} from '../definitions/document-types';

@Injectable({
    providedIn: 'root'
})
export class AdjustDetailLinesDatesService {

    constructor(private generalService: GeneralService,
                private docTypes: DocumentTypes) {
    }

    adjustDates(doc: DocumentModel) {
        if (doc.documentType !== this.docTypes.RETURN
            && doc.documentType !== this.docTypes.OFFHIRE) {
            if (doc.detailLines.length > 0) {
                let alertDateChange = false;
                for (const line of doc.detailLines) {
                    if (line.fromDate < doc.scheduledDate) {
                        line.fromDate = doc.scheduledDate;
                        alertDateChange = true;
                    }
                    if (line.toDate < line.fromDate) {
                        line.toDate = line.fromDate;
                    }
                }
                if (alertDateChange) {
                    this.generalService.createToast('Dates changed in the detail lines');
                }
            }
        }
    }
}
